var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createPortal } from 'react-dom';
import { useRenderTarget } from './hooks/useRenderTarget';
import { useTabObserver } from './hooks/useTabObserver';
const createTabOutHandler = () => {
    const activeElement = typeof document === 'undefined' ? null : document.activeElement;
    return () => {
        if (activeElement === null) {
            return;
        }
        activeElement.focus();
    };
};
export const Portal = (_a) => {
    var { children, onTabOut = createTabOutHandler() } = _a, props = __rest(_a, ["children", "onTabOut"]);
    const renderTarget = useRenderTarget(props);
    useTabObserver({ root: renderTarget, onTabOut });
    if (renderTarget === null) {
        return null;
    }
    return createPortal(children, renderTarget);
};
